export const validateEmail = (email?: string) => {
  const re = /\S+@\S+\.\S+/;

  if (!email) {
    return false;
  }
  return re.test(email);
};
